export default "__VITE_ASSET__42d5cbe9__"